module.exports = __webpack_public_path__ + "img/Phone_04.070e5a20.jpg";